import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/financial-product-tables-details`

export default ({ amortizationId }) => {
  return http.get(`${api}/${amortizationId}`)
}
